'use client';
import { FilterIcon } from 'lucide-react';
import { Button } from '../../components/button';

import { attendantsFilterTitle } from '@bells/i18n';
import { useFilter } from './filter-provider';

const AttendantFilterButton = ({className}: {className?:string}) => {
  const { setShowFilter, totalFilters } = useFilter();
  return (
    <Button
      variant={'outline'}
      className={className}
      size={'sm'}
      onClick={() => {
        setShowFilter(true);
      }}
    >
      <FilterIcon />
      <span>
        {attendantsFilterTitle()}{' '}
        {totalFilters > 0 && (
          <span className='text-brand'>({totalFilters})</span>
        )}
      </span>
    </Button>
  );
};

export { AttendantFilterButton };
